import React, {Component} from 'react';
import {Row, Col, Checkbox} from 'react-bootstrap';
import moment from 'moment/moment';

class MessageHeader extends Component {
  onMessageChecked = (event, id) => this.props.onMessageChecked(id, event.target.checked);

  render() {
    const {checked, message, checkbox} = this.props;

    const createdAt = moment(message.attributes['created-at'])
      .format('DD/MM/YYYY');

    return (
      <Row>
        <Col lg={12}>
          {createdAt}
          {checkbox && (
          <Checkbox
            inline
            checked={checked}
            onChange={e => this.onMessageChecked(e, message.id)}
            className="pull-right check-message"
          />
)}
        </Col>
      </Row>
    );
  }
}

export default MessageHeader;



// WEBPACK FOOTER //
// ./src/components/team/my-messages/message-header.jsx